import { render, staticRenderFns } from "./ellipsis-text.vue?vue&type=template&id=0acce701&scoped=true"
import script from "./ellipsis-text.vue?vue&type=script&lang=js"
export * from "./ellipsis-text.vue?vue&type=script&lang=js"
import style0 from "./ellipsis-text.vue?vue&type=style&index=0&id=0acce701&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acce701",
  null
  
)

export default component.exports